require('./bootstrap');

import Alpine from 'alpinejs'
 
window.Alpine = Alpine
 
Alpine.start()

window.triggerInputChange = (item) =>{
    setTimeout(function () {
        item.trigger('change')
    }, 200);
}

$(document).ready(function () {
    $('.question-container').each(function (item) {
        let text = $(this).find('.question-text').html();
        $(this).popover({
            content: text,
            html: true,
            placement: 'auto',
            trigger: 'hover',
            //delay: { "show": 0, "hide": 1000000000 }
        })
    })

    $('.custom-checkbox-container').on('click', function() {
        let checkbox = $(this).find('.checkbox');
        let input = $(this).find('input[type="checkbox"]');

        if($(checkbox).hasClass('checked')) {
            $(checkbox).removeClass('checked');
            $(input).attr('checked', false);
        } else {
            $(checkbox).addClass('checked');
            $(input).attr('checked', true);
        }
    });

    $('#room-create-button').on('click', function(e) {
        e.preventDefault();
        if($('#other-than-box').prop('checked') == true) {
            $('#other-than-box-modal').modal('toggle');
        } else {
            $(this).closest('form').submit();
        }
    });

    $('input[name=new_existing]').on('change', function(){
        $('#room-update-fourth-btn').data('new', $('input[name=new_existing]:checked').val())
    });

    $('#room-update-fourth-btn').on('click', function(e) {
        if($(this).data("new") === "existing" && $(this).data("ceiling") === "cw-90" ){
            e.preventDefault();
            $('#cw-90-existing-box-modal').modal('toggle');
        }
    });

    $('#cw-90-existing-box-modal-btn').on('click', function(){
        $(this).closest('form').submit();
    });

    $('#room-width').on('change', function() {
        let width_value = parseFloat($(this).val().replace(',','.'));
        let length_value = parseFloat($('#room-length').val().replace(',','.'));

        if(width_value < 1.5) {
            $(this).val(1.5);
        }
        if(width_value > 100) {
            $(this).val(10);
        }
        if(length_value > 0 && length_value <= 100 && width_value > 0 && width_value <= 100) {
            let floorspace = width_value * length_value;

            $('#floorspace').val(floorspace.toFixed(3));

            let smaller = Math.min(width_value , length_value);

            if(smaller > 5) {
                let zones = calculateZones();

                let res = '';
                let serial = 1;
                for(let zone in zones) {
                    res += serial.toString() + '.zóna: ' + zones[zone] + ' m <br>';
                    serial++;
                }

                $('#zone-container').removeClass('d-none').find('.zones').html(res);
            } else {
                $('#zone-container').addClass('d-none');
            }
        }
    });

    $('#room-length').on('change', function() {
        let length_value = parseFloat($(this).val().replace(',','.'));
        let width_value = parseFloat($('#room-width').val().replace(',','.'));
        if(length_value < 1.5) {
            $(this).val('1,5');
        }
        if(length_value > 100) {
            $(this).val(10);
        }
        if(width_value > 0 && width_value <= 100 && length_value > 0 && length_value <= 100) {
            let floorspace = length_value * width_value;

            $('#floorspace').val(floorspace.toFixed(3));

            let smaller = Math.min(length_value , width_value);

            if(smaller > 5) {
                let zones = calculateZones();

                let res = '';
                let serial = 1;
                for(let zone in zones) {
                    res += serial.toString() + '.zóna: ' + zones[zone] + ' m <br>';
                    serial++;
                }

                $('#zone-container').removeClass('d-none').find('.zones').html(res);
            } else {
                $('#zone-container').addClass('d-none');
            }
        }
    });

    $('.play-button').on('click', function(e) {
        let video = $(this).data('video');

        $('#product-video').find('video').attr('src', video);
        $('#product-video').modal('toggle');
        e.stopPropagation();
    });

    window.showControlledPopower = function () {
        $('#required_controller').popover('show');
    }

    $("html").on("mouseup", function (e) {
        var l = $(e.target);
        if (l[0].className.indexOf("popover") == -1) {
            $(".popover").each(function () {
                $(this).popover("hide");
            });
        }
    });

    // $("#controlled_0_label").on('click', function (e) {
    //     console.log('asd', $(this).data("value"));
    //     if($(this).data("value")){
    //         e.preventDefault();
    //         $("#required_controller").toggleClass("hovered");
    //     }
    // });

    // $('#room-width').on('keyup', function(){
    //     var data = $(this).val();
    //     var regex = /^[0-9],[0-9]$/g;
    //     var notregex = /^[^0-9,]$/g;
    //
    //     if(!data.match(regex)){
    //         data = data.replaceAll(notregex, "");
    //     }
    //     $(this).val(data);
    // });
    $('#room-width, #room-length').on('keyup', function(){
        if($(this).val().includes('.')) {
            let newVal = $(this).val().replace('.', ',');
            $(this).val(newVal);
        }
    });
});

function calculateZones() {
    // Declare smaller, bigger, floorspace and premade items
    let width_value = parseFloat($('#room-width').val().replace(',','.'));
    let length_value = parseFloat($('#room-length').val().replace(',','.'));
    let smaller = Math.min(width_value , length_value);
    let bigger = Math.max(length_value , width_value);
    let floorspace = smaller * bigger;

    // Only cut zones when smaller side more that 5m
    if(smaller > 5) {
        let zones = [];

        // Cut the room for x zones
        let zonecount = Math.ceil(smaller / 5);

        // Display the usable zones
        for(let i = 0; i < zonecount; i++){
            let zoneSmaller = smaller / zonecount;
            zones.push(`${Number.parseFloat(zoneSmaller.toFixed(3))}` + 'x' + bigger);
            // zones.push(`${zoneSmaller.toFixed(3)}` + 'x' + bigger);
        }

        return zones;
    }
}

function choose_premade(num){
    let premade = [];
    for(let i = 1.24; i <= 4.65; i += 0.31){
        if(num > i){
            premade.push(i);
        }
    }
    let chosen = Math.max.apply(Math, premade);

    return chosen;
}